import { render, staticRenderFns } from "./CredenciamentoFornecedorResultado.vue?vue&type=template&id=51497904"
import script from "./CredenciamentoFornecedorResultado.vue?vue&type=script&lang=js"
export * from "./CredenciamentoFornecedorResultado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports